module.exports = __webpack_public_path__ + "media/images/desktop/stop-block-d61d8f5a00bf1efbcfc7cff88deb1c7e.svg";